import { Injectable } from '@angular/core';
import { CaiApi } from '../../utils/cai-api';
import { IBlobFile } from '../../model/blob-file.model';
import { IAirlineRate } from '../../model/airline-rate.model';
import { API_CORE } from '../../constant/api-core.const';

@Injectable({
  providedIn: 'root',
})
export class MarketRateService {
  async createMarketRate(
    marketRate: IAirlineRate,
    token?: string,
  ): Promise<IAirlineRate> {
    let extraOptions;
    if (token) {
      extraOptions = {
        queryParams: {
          token,
        },
        body: marketRate,
      };
    } else {
      extraOptions = {
        body: marketRate,
      };
    }
    return CaiApi.post(
      API_CORE.name,
      API_CORE.URLs.MarketRate.MarketRates,
      extraOptions,
    );
  }

  async updateMarketRate(marketRate: IAirlineRate): Promise<IAirlineRate> {
    return CaiApi.post(API_CORE.name, API_CORE.URLs.MarketRate.MarketRates, {
      body: marketRate,
    });
  }

  async deleteMarketRate(rateId: number): Promise<IAirlineRate> {
    const url = API_CORE.URLs.MarketRate.MarketRates.concat('/').concat(
      rateId.toString(),
    );
    return CaiApi.del(API_CORE.name, url, {});
  }

  async exportExcel(
    airline: string,
    selectedOfficeId?: number,
    origin?: string,
    country?: string,
    rateTable?: string,
    agreementAirline?: string,
    rateCategory?: string,
    departureDate?: string,
    rateId?: number,
  ): Promise<IBlobFile> {
    const extraOptions: any = {
      queryParams: {},
    };
    if (origin) {
      extraOptions.queryParams.origin = origin;
    }
    if (airline) {
      extraOptions.queryParams.airline = airline;
    }
    if (selectedOfficeId) {
      extraOptions.queryParams.officeId = selectedOfficeId;
    }
    if (country) {
      extraOptions.queryParams.country = country;
    }
    if (rateTable) {
      extraOptions.queryParams.type = rateTable;
    }
    if (agreementAirline) {
      extraOptions.queryParams.agreementAirline = agreementAirline;
    }
    if (rateCategory) {
      extraOptions.queryParams.rateCategory = rateCategory;
    }
    if (departureDate) {
      extraOptions.queryParams.departureDate = departureDate;
    }
    if (rateId) {
      extraOptions.queryParams.rateId = rateId;
    }
    return CaiApi.get(
      API_CORE.name,
      API_CORE.URLs.MarketRate.ExportCSV,
      extraOptions,
    );
  }

  async getMarketRates(
    page: number,
    size: number,
    sort: string,
    origin?: string,
    airline?: string,
    selectedOfficeId?: number,
    filterHistory?: boolean,
    rateTable?: string,
    agreementAirline?: string,
    country?: string,
    search?: string,
    commodity?: string,
    destination?: string,
    rateCategory?: string,
    aircraftTypes?: string,
    departureDate?: string,
  ): Promise<IAirlineRate[]> {
    const extraOptions: any = {
      queryParams: {
        page,
        size,
        sort,
      },
    };
    if (selectedOfficeId) {
      extraOptions.queryParams.officeId = selectedOfficeId;
    }
    if (country) {
      extraOptions.queryParams.country = country;
    }
    if (origin) {
      extraOptions.queryParams.origin = origin;
    }
    if (airline) {
      extraOptions.queryParams.airline = airline;
    }
    if (filterHistory) {
      extraOptions.queryParams.filterHistory = filterHistory;
    }
    if (search) {
      extraOptions.queryParams.search = search;
    }
    if (commodity) {
      extraOptions.queryParams.commodity = commodity;
    }
    if (destination) {
      extraOptions.queryParams.destination = destination;
    }
    if (rateCategory) {
      extraOptions.queryParams.rateCategory = rateCategory;
    }
    if (aircraftTypes) {
      extraOptions.queryParams.aircraftType = aircraftTypes;
    }
    if (departureDate) {
      extraOptions.queryParams.departureDate = departureDate;
    }
    if (rateTable) {
      extraOptions.queryParams.type = rateTable;
    }
    if (agreementAirline) {
      extraOptions.queryParams.agreementAirline = agreementAirline;
    }
    return CaiApi.get(
      API_CORE.name,
      API_CORE.URLs.MarketRate.MarketRates,
      extraOptions,
    );
  }
}
